import React, { FunctionComponent } from "react";
import { MY_COLOR, GOLD_COLOR } from "../../../../constants/colors";

interface PlayerWithScoreProps {
  username: string;
  score?: number;
  isMe: boolean;
  isCorrect: boolean;
}

const PlayerWithScore: FunctionComponent<PlayerWithScoreProps> = (props) => {
  return (
    <div
      style={{
        ...{ fontSize: "12px", marginTop: 8, color: "white" },
        ...(props.isCorrect ? { color: "black", fontWeight: "bold" } : {}),
        ...(props.isMe ? { color: MY_COLOR, fontWeight: "bold" } : {})
      }}
    >
      {props.username} +{props.score}
    </div>
  );
};
export default PlayerWithScore;
